<template>
	<div class="px-5">
		<app-table
			class="my-5 is-not-selectable pb-4"
			name="global-roles"
			:columns="columns"
			:current-page="currentPage"
			:rows="table.rows"
			:last-page="table.lastPage"
			@on-page="changePage"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.code }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.descripcion }}
				</td>
				<td>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar Rol"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="error"
						icon="delete"
						text="Eliminar Rol"
						@click-icon="openModalConfirmation(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<v-dialog v-model="dialog" persistent max-width="500">
			<v-card>
				<v-card-title class="subheading">
					<p class="dialog-title">¿Seguro que quiere eliminar este rol global?</p>
				</v-card-title>
				<h2 class="text-xs-center">"{{currentGlobalRol.name}}"</h2>
				<v-card-actions class="justify-center mt-3">
					<v-btn
						class="btn-action"
						color="green"
						dark
						@click.native="deleteGlobalRole"
					>SI</v-btn>
					<v-btn
						class="btn-action"
						color="error"
						dark
						@click.native="closeDialog"
					>NO</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function created() {
	const { codeProject } = this.$route.params;
	const url = `types-roles?codeProject=${codeProject}`;
	this.loadData(url, 1);
}

function edit(rol) {
	this.$emit('edit-role', rol);
}

function openModalConfirmation(rol) {
	this.dialog = true;
	this.currentGlobalRol = { ...rol };
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
}

function closeDialog() {
	this.dialog = false;
}

async function deleteGlobalRole() {
	const { id: roleId } = this.currentGlobalRol;
	const url = `types-roles/${roleId}`;
	await this.$http.delete(url);
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Código', checked: true, visible: true },
			{ id: 2, name: 'Nombre', checked: true, visible: true },
			{ id: 3, name: 'Descripción', checked: true, visible: true },
			{ id: 4, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
		currentGlobalRol: {},
		currentPage: 1,
		dialog: false,
	};
}

export default {
	name: 'roles-global-list',
	components: {
		appTooltipButton,
	},
	created,
	data,
	methods: {
		changePage,
		closeDialog,
		deleteGlobalRole,
		edit,
		openModalConfirmation,
	},
};
</script>
<style lang="scss" scoped>
	.dialog-title {
		text-align: center;
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/roles/roles-global-list.vue